import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {EditorModule} from '@tinymce/tinymce-angular';
import {FormsModule} from '@angular/forms';

@Component({
    selector: 'app-editor',
    templateUrl: './editor.component.html',
    styleUrls: ['./editor.component.css'],
    imports: [
        EditorModule,
        FormsModule
    ]
})
export class EditorComponent implements OnInit {
  textValue: string;
  @Output() textChange = new EventEmitter<string>();
  @Input()
  get text() {
    return this.textValue;
  }
  set text(val) {
    this.textValue = val;
    this.textChange.emit(val);
  }

  constructor() { }

  ngOnInit() {
  }

}
